import { APIPaths } from "@/apis/api-config";
import BaseApi from "@/apis/base-api";

export class WorkspaceUserApi extends BaseApi {
  async getWorkspaceUserList(
    params: APIPaths["/partner-app/workspace-user/list"]["get"]["parameters"]["query"],
  ): Promise<APIPaths["/partner-app/workspace-user/list"]["get"]["responses"]["200"]["content"]["application/json"]> {
    return (await this.get("/partner-app/workspace-user/list", { params })).data;
  }

  async postWorkspaceUserNew(
    requestBody: APIPaths["/admin-dash/workspace-user/new"]["post"]["requestBody"]["content"]["application/json"],
  ): Promise<APIPaths["/admin-dash/workspace-user/new"]["post"]["responses"]["200"]["content"]["application/json"]> {
    return (await this.post("/admin-dash/workspace-user/new", requestBody)).data;
  }

  async getWorkspaceUserById(
    id: string,
  ): Promise<APIPaths["/admin-dash/workspace-user/{id}"]["get"]["responses"]["200"]["content"]["application/json"]> {
    return (await this.get(`/admin-dash/workspace-user/${id}`)).data;
  }

  async patchWorkspaceUserById(
    id: string,
    requestBody: APIPaths["/admin-dash/workspace-user/{id}"]["patch"]["requestBody"]["content"]["application/json"],
  ): Promise<APIPaths["/admin-dash/workspace-user/{id}"]["patch"]["responses"]["200"]["content"]["application/json"]> {
    return (await this.patch(`/admin-dash/workspace-user/${id}`, requestBody)).data;
  }

  async deleteWorkspaceUserById(
    id: string,
  ): Promise<APIPaths["/admin-dash/workspace-user/{id}"]["delete"]["responses"]["200"]["content"]["application/json"]> {
    return (await this.delete(`/admin-dash/workspace-user/${id}`)).data;
  }

  async putWorkspaceUserStatusById(
    id: string,
    requestBody: APIPaths["/admin-dash/workspace-user/{id}/status"]["put"]["requestBody"]["content"]["application/json"],
  ): Promise<
    APIPaths["/admin-dash/workspace-user/{id}/status"]["put"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.put(`/admin-dash/workspace-user/${id}/status`, requestBody)).data;
  }

  async putWorkspaceUserPositionById(
    id: string,
    requestBody: APIPaths["/admin-dash/workspace-user/{id}/position"]["put"]["requestBody"]["content"]["application/json"],
  ): Promise<
    APIPaths["/admin-dash/workspace-user/{id}/position"]["put"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.put(`/admin-dash/workspace-user/${id}/position`, requestBody)).data;
  }
}
